import styled from '@emotion/styled';

const EmailIcon = styled('span')({
  fontSize: '3rem',
  margin: '0 1rem 0 0',
});

export default EmailIcon;
